module.exports = __webpack_public_path__ + "img/creditCard.1754feb1.svg";